module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0c76be5a471779295b92b46a8db50647"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
